import { assign, get } from 'lodash';
import * as api from 'api/api-authentication';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
  data: {},
  meta: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InstanceInfo: state => state,
};

const actions = {
  GetInstanceInfo({ commit }, query) {
    commit(types.FETCH_INSTANCE_INFO_START);

    query = query || {};

    api.authInstanceInfo(
      query,
      (response) => {
        commit(types.RECEIVE_INSTANCE_INFO, { response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_INSTANCE_INFO_NOT_FOUND, { error });
        } else {
          commit(types.FETCH_INSTANCE_INFO_ERROR, { error });
        }
      },
    );
  },
  UpdateInstanceInfo({ commit }, params) {
    const response = get(params, 'response', {});
    commit(types.UPDATE_INSTANCE_INFO, { response });
  },
  ClearInstanceInfo({ commit }) {
    commit(types.CLEAR_INSTANCE_INFO_STORE);
  },
};

const mutations = {
  [types.FETCH_INSTANCE_INFO_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_INSTANCE_INFO_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.FETCH_INSTANCE_INFO_NOT_FOUND](state) {
    assign(state, neutralState, { notFound: true });
  },
  [types.RECEIVE_INSTANCE_INFO](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },

  [types.CLEAR_INSTANCE_INFO_STORE](state) {
    assign(state, initState);
  },

  [types.UPDATE_INSTANCE_INFO](state, { response }) {
    console.log('UPDATE_INSTANCE_INFO', response);
    assign(state, neutralState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/entities/instance-info.js